import React from 'react';

function TopBar({ onOpenPalette }) {
  return (
    <div className="platform-topbar">
      <button type="button" className="platform-topbar-search" onClick={onOpenPalette}>
        <span className="platform-topbar-search-icon">⌘</span>
        <span className="platform-topbar-search-text">Search anything...</span>
        <kbd className="platform-topbar-kbd">K</kbd>
      </button>
    </div>
  );
}

export default TopBar;
